module.exports = require("@swa-ui/vacations/src/ManageMyVacationsForm/ManageMyVacationsForm.module.scss");